import React, { useState, useEffect } from 'react';
import { Tag, Plus, X, Check } from 'lucide-react';
import { toast } from 'sonner';
import * as api from '../services/api';

export default function LeadTagsWidget({ lead, setLead, canEdit }) {
  const [allTags, setAllTags] = useState([]);
  const [showSelector, setShowSelector] = useState(false);

  useEffect(() => {
    api.getLeadTags().then(setAllTags).catch(() => {});
  }, []);

  const leadTags = lead?.tags || [];

  const toggleTag = async (tagId) => {
    const newTags = leadTags.includes(tagId)
      ? leadTags.filter(t => t !== tagId)
      : [...leadTags, tagId];
    try {
      await api.updateLeadTags(lead.id, newTags);
      setLead(prev => ({ ...prev, tags: newTags }));
    } catch { toast.error('Error al actualizar etiquetas'); }
  };

  const tagMap = {};
  allTags.forEach(t => { tagMap[t.id] = t; });

  return (
    <div className="col-span-2 pt-2 border-t border-slate-100">
      <p className="text-xs text-slate-500 mb-2">Etiquetas</p>
      <div className="flex flex-wrap gap-1.5">
        {leadTags.map(tid => {
          const t = tagMap[tid];
          if (!t) return null;
          return (
            <span key={tid} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium text-white"
              style={{ backgroundColor: t.color }}>
              {t.name}
              {canEdit && (
                <button onClick={() => toggleTag(tid)} className="hover:bg-white/20 rounded-full p-0.5">
                  <X className="w-3 h-3" />
                </button>
              )}
            </span>
          );
        })}
        {canEdit && (
          <button onClick={() => setShowSelector(!showSelector)}
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border border-dashed border-slate-300 text-slate-500 hover:border-slate-400 hover:text-slate-700"
            data-testid="add-lead-tag-btn">
            <Plus className="w-3 h-3" /> Etiqueta
          </button>
        )}
      </div>
      {showSelector && canEdit && (
        <div className="mt-2 p-2 bg-slate-50 rounded-lg border border-slate-200">
          <div className="flex flex-wrap gap-1.5">
            {allTags.filter(t => !leadTags.includes(t.id)).map(t => (
              <button key={t.id} onClick={() => toggleTag(t.id)}
                className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium text-white hover:opacity-80 transition-opacity"
                style={{ backgroundColor: t.color }}>
                <Plus className="w-3 h-3" /> {t.name}
              </button>
            ))}
            {allTags.filter(t => !leadTags.includes(t.id)).length === 0 && (
              <p className="text-xs text-slate-400">No hay más etiquetas disponibles</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
